module.exports = __webpack_public_path__ + "img/creditcard_security1.d5000e12.svg";